export default __webpack_public_path__ + "static/button_w.8304e4964be37512f4b420f5e592e728.svg";